import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import './PlanningGridLines.scss'
import { listTimes, listNumbers } from '@teqplay/viewer'

export default class PlanningGridLines extends PureComponent {
  static propTypes = {
    startTime: PropTypes.object.isRequired,
    endTime: PropTypes.object.isRequired,
    quays: PropTypes.array.isRequired,
    timeToScreen: PropTypes.func.isRequired,
    bollardToScreen: PropTypes.func.isRequired
  }

  render() {
    const times = listTimes(this.props.startTime, this.props.endTime)
    const bollards = listNumbers(
      this.props.quays[0].minBollard,
      this.props.quays[this.props.quays.length - 1].maxBollard
    )

    return (
      <div className="planning-grid-lines">
        {times.map((time, index) => {
          const top = this.props.timeToScreen(time)
          return <div key={index} style={{ top }} className="time-axis-grid-line" />
        })}
        {bollards.map((bollard, index) => {
          const left = this.props.bollardToScreen(bollard)
          const quayStart = this.props.quays.find(quay => quay.minBollard === bollard)
          const terminalEnd = this.props.quays[this.props.quays.length - 1].maxBollard === bollard

          return (
            <div
              key={index}
              style={{ left }}
              className={`vertical-axis-grid ${quayStart || terminalEnd ? 'quay-border' : ''}`}
            />
          )
        })}
      </div>
    )
  }
}
